/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';
import { classNames } from '../utils/UNSAFE_classNames';
import { messageStartIconStyles } from './themes/MessageStyles.css';
import { MessageRendererDataItem } from './Message.types';

/**
 * Props for the StartIcon component
 */
type Props<K, D> = {
  /**
   * The data item for rendering the start icon
   */
  item: MessageRendererDataItem<K, D>;

  /**
   * A custom renderer for rendering the start icon
   */
  renderer: (item: MessageRendererDataItem<K, D>) => ComponentChildren;
};

/**
 * Component for rendering custom icon/content for start icon in Message
 */
function MessageCustomStartIcon<K, D>({ item, renderer }: Props<K, D>) {
  // TODO:  Refactor to utilize useComponentTheme and multiVariantStyles.
  const classes = classNames([
    messageStartIconStyles.base,
    // for now only toast has support for custom icon
    messageStartIconStyles.toast,
    messageStartIconStyles.customToast
  ]);
  return (
    <div class={classes} role="presentation" data-oj-message-custom-icon="">
      {renderer(item)}
    </div>
  );
}

export { MessageCustomStartIcon };
